import React, { Fragment } from 'react';

const About = () => {
  return (
    <Fragment>
      <section id='about' className='about'>
        <div className='container' data-aos='fade-up'>
          <div className='section-title'>
            <h2 style={{ color: '#1a3f36' }}>About Us</h2>
          </div>

          <div className='row content'>
            <div className='col-lg-6'>
              <p>
                We have developed superior and powerful powders that absorb and prevent the development of carcinogenic
                substances formed during frying operations.
              </p>
              <p>
                Our products help frying users meet regulatory and food safety requirements while extending oil lifespan
                and preserving the oil's quality, ensuring frying oil stays fresh and fried food tastes fantastic
                (suitable for use with all types of frying oils).
              </p>
              <p>
                Beyond Oil is an innovative food-tech company dedicated to transforming the way we consume and produce
                food. We provide sustainable solutions for the food industry, prioritizing environmental protection and
                the well-being of its workers and customers.
              </p>
              <p>
                Our product is approved by the FDA, the Standards Institute, and the Canadian Institute. It also holds
                kosher and halal certification and an ISO 9001 mark.
              </p>
            </div>
            <div className='col-lg-6 pt-4 pt-lg-0'>
              <p>
                <b>Our Goals:</b>
              </p>
              <ul>
                <li>
                  <i className='ri-check-double-line'></i> Simple and easy implementation of beyond oil for any
                  customer, anywhere in the world.
                </li>
                <li>
                  <i className='ri-check-double-line'></i> Remote support for the ongoing operation of the product
                  during and after the implementation
                </li>
                <li>
                  <i className='ri-check-double-line'></i> Harnessing all customers for the success of the process by
                  understanding the contribution to their health, to the health of the customers, to the contribution to
                  the environment, to the optimization of the work process and financial savings
                </li>
                <li>
                  <i className='ri-check-double-line'></i> Creating a barrier-breaking sales tool for assimilating
                  beyond oil among new customers
                </li>
              </ul>
              {/* <a href='/#' className='btn-learn-more'>
                Learn More
              </a> */}
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default About;
